import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=5a2cbed6&scoped=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=5a2cbed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cbed6",
  null
  
)

export default component.exports